import { Error } from 'components/common/error/Error';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  getAbandonedCartThunk,
  patchAbandonedCartThunk
} from 'state/abandoned-cart/abandoned-cart-thunks';
import { setError } from 'state/abandoned-cart/abandoned-cart-slice'
import { useAbandonedCart } from 'components/abandoned-cart/hooks/useAbandonedCart';
import { usePopulateAbandonedCartJourney } from 'components/abandoned-cart/hooks/usePopulateAbandonedCartJourney';
import { initiateThunk } from 'state/initiate/initiate-thunks';
import { useNavigation } from 'hooks/useNavigation';
import {
  AbandonedCartUpdateStep,
  useAbandonedCartUpdate
} from 'hooks/useAbandonedCart/useAbandonedCartUpdate';
import { getErrors } from 'api/client';

export const AbandonedCart = () => {
  const dispatch = useAppDispatch();
  const populateAbandonedCartJourney = usePopulateAbandonedCartJourney()
  const { next, eventTypes } = useNavigation();
  const {
    quoteId,
    isLoading,
    apiErrors,
    getIsQuoteExpired
  } = useAbandonedCart();
  const { payload } = useAbandonedCartUpdate(AbandonedCartUpdateStep.RETURNED);

  const hasFetchedAbandonedCart = useRef(false);
  const [isRedirecting, setIsRedirecting] = useState(true);

  const showSpinner = isLoading || isRedirecting;

  const fetchQuote = useCallback(async () => {
    await dispatch(initiateThunk());
    const abandonedCart = await dispatch(getAbandonedCartThunk(quoteId));
    await populateAbandonedCartJourney(abandonedCart);
    await dispatch(patchAbandonedCartThunk(payload, quoteId));

    const isQuoteExpired = getIsQuoteExpired(abandonedCart);
    if (isQuoteExpired) {
      return eventTypes.QUOTE_EXPIRED;
    }

    return eventTypes.NEXT;
  }, [
    dispatch,
    quoteId,
    populateAbandonedCartJourney,
    payload,
    getIsQuoteExpired,
    eventTypes.NEXT,
    eventTypes.QUOTE_EXPIRED
  ]);

  useEffect(() => {
    if (!hasFetchedAbandonedCart.current && !!quoteId) {
      hasFetchedAbandonedCart.current = true;

      fetchQuote()
        .then((eventType) => next({ eventType: eventType }))
        .catch(e => {
          console.error(e);
          const errors = getErrors(e);
          dispatch(setError(errors));
        })
        .finally(() => setIsRedirecting(false));
    }
  }, [fetchQuote, quoteId, next, dispatch]);

  if (apiErrors) {
    return (
      <div data-testid="error-panel">
        <NsPanel>
          <Error errors={apiErrors} />
        </NsPanel>
      </div>
    );
  }
  if (showSpinner) return <div data-testid="spinner"><NsStopgap /></div>;
};

export default AbandonedCart;
